import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  height: ${({ theme }) =>
    theme.isMobile ? `calc(100dvh - 6.4rem)` : '100dvh'};
  width: 100%;
  padding-right: ${({ theme }) => theme.spacing(0.5)};

  overflow: auto;
`;

export const Main = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(1.5)};

  padding: ${({ theme }) =>
    `${theme.spacing(2)} ${theme.spacing(1.5)} ${theme.spacing(2)} ${theme.spacing(2)}`};
  min-width: 0;
`;

export const MainContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;

  border: ${({ theme }) => `1px solid ${theme.palette.divider}`};
  background: ${({ theme }) => theme.palette.background.default};
  border-radius: ${({ theme }) => theme.spacing(3)};
  box-shadow: ${({ theme }) => theme.shadowBox.contentBlock};

  overflow: hidden;
`;

export const Content = styled.div`
  flex: 1;
  padding: ${({ theme }) => `0 0 ${theme.spacing(10)}`};

  overflow: auto;
`;
